/**
 * Simplified Usersnap loader - shows widgets specified in the widgetKeys array.
 * Automatically filters out internal widgets in production environments.
 *
 * @param {Object} event - The Usersnap load event
 * @param {Object} api - The Usersnap API instance
 * @param {string|Object|Array} widgetKeys - Widget key(s) to show. Can be:
 *   - String: 'widget-id'
 *   - Object: { id: 'widget-id', internal: true }
 *   - Array: [widgetKey1, widgetKey2, ...]
 *
 * @example
 * // Show multiple widgets (internal widgets auto-filtered in production)
 * loadUsersnap(event, api, [
 *   USERSNAP_WIDGETS.SCROLLABLE_INTERNAL_FEEDBACK,  // Hidden in production
 *   USERSNAP_WIDGETS.SCROLLABLE_USER_BUG_REPORT,    // Always shown
 * ])
 */
export const loadUsersnap = (event, api, widgetKeys) => {
  const isProduction = process.env.NODE_ENV === "production";

  // Normalize to array for consistent handling
  const keys = Array.isArray(widgetKeys) ? widgetKeys : [widgetKeys];

  // Filter out undefined/null keys and extract IDs
  const validKeys = keys
    .filter(Boolean)
    .filter((key) => {
      // If it's an object with internal flag, filter out in production
      if (typeof key === "object" && key.internal && isProduction) {
        return false;
      }
      return true;
    })
    .map((key) => {
      // Extract ID if it's an object, otherwise use as-is
      return typeof key === "object" ? key.id : key;
    });

  if (validKeys.includes(event.apiKey)) {
    api.show(event.apiKey);
  } else {
    // Hide widgets not in the list
    api.hide(event.apiKey);
  }
};
